import { INFO, INFO_CONTROLLERS } from './controllers/info';
import { OVERLAY, OVERLAY_CONTROLLERS } from './controllers/overlay';
import { VIDEO, VIDEO_CONTROLLERS } from './controllers/video';
import { GALLERY, GALLERY_CONTROLLERS } from './controllers/gallery';
import { FULLSCREEN, FULLSCREEN_CONTROLLERS } from './controllers/fullscreen';
import { STYLABLE } from './controllers/stylable';
import { SETTINGS } from './controllers/settings';
export const PRIVATE_CONTROLLERS = {
  INFO,
  OVERLAY,
  VIDEO,
  GALLERY,
  FULLSCREEN,
  STYLABLE,
  SETTINGS
};
const ControllerGroups = {
  INFO: INFO_CONTROLLERS,
  OVERLAY: OVERLAY_CONTROLLERS,
  VIDEO: VIDEO_CONTROLLERS,
  GALLERY: GALLERY_CONTROLLERS,
  FULLSCREEN: FULLSCREEN_CONTROLLERS
};
export function migratePrivateControllers(originalOptions, explicitControllerGroups) {
  if (explicitControllerGroups === void 0) {
    explicitControllerGroups = ['INFO', 'OVERLAY', 'VIDEO', 'GALLERY', 'FULLSCREEN'];
  }
  let options = {
    ...originalOptions
  };
  // for each in explicitControllerGroups
  explicitControllerGroups.forEach(group => {
    Object.keys(ControllerGroups[group]).forEach(key => {
      const value = originalOptions[key];
      if (value !== undefined) {
        const handler = ControllerGroups[group][key];
        if (typeof handler === 'function') {
          options = {
            ...options,
            ...(handler(value, options) || {})
          };
        } else {
          options[handler] = value;
        }
      }
    });
  });
  return options;
}
//# sourceMappingURL=index.js.map